import update from 'immutability-helper';

import * as AppConst from '../constants/App';
import * as SearchConst from '../constants/Search';
import * as ObjectConst from '../constants/Property';
import * as ActionTypes from '../constants/ActionTypes';

const initialState = () => ({
    isFirstSearch: true,
    isHorizontalMode: false,
    isShowAllFilters: false,
    isShowAdvancedSearch: false,
    searchResult: {
        rows: [],
        paging: {}
    },
    rangeAreaSettings: {
        min: 0,
        max: 100000
    },
    rangePriceSettings: {
        min: 0,
        max: 100000000
    },
    requestParams: {
        page: 1,
        minArea: 0,
        minPrice: 0,
        typeTerms: [],
        amenities: [],
        lifestyles: [],
        poolValues: [],
        maxArea: 100000,
        floorValues: [],
        viewsValues: [],
        garageValues: [],
        gardenValues: [],
        newTypeValues: [],
        kitchenValues: [],
        typeApartments: [],
        maxPrice: 100000000,
        rangeTypeValues: [],
        conditionValues: [],
        orientationValues: [],
        type: ObjectConst.TYPE.RENT,
        pageSize: SearchConst.PAGE_SIZES[0],
        embed: [ObjectConst.EMBED.IMAGES, ObjectConst.EMBED.TRANSLATES],
        dataPageEmbed: [ObjectConst.DATA_PAGE_EMBED.OBJECT_ADDITIONAL_INFO]
    }
});

export default (state = initialState(), action) => {
    let index;
    let requestParams;

    switch (action.type) {
        case ActionTypes.SET_SEARCH_TYPE:
            requestParams = update(state.requestParams, {
                type: {$set: action.payload.type}
            });
            return {...state, searchType: action.payload.searchType, requestParams: requestParams};
        case ActionTypes.SET_SEARCH_RESULT:
            const response = {
                ...state,
                searchResult: action.payload
            };
            const {
                meta: {
                    objectAdditionalInfo: {
                        maxArea,
                        maxPrice
                    }
                }
            } = action.payload;

            if (state.isFirstSearch) {
                requestParams = update(state.requestParams, {
                    maxArea: {$set: maxArea < 1 ? 1 : maxArea},
                    maxPrice: {$set: maxPrice < 1 ? 1 : maxPrice}
                });
                response.requestParams = requestParams;
                response.isFirstSearch = false;
            }

            const rangeAreaSettings = update(state.rangeAreaSettings, {
                max: {$set: maxArea < 1 ? 1 : maxArea}
            });
            response.rangeAreaSettings = rangeAreaSettings;

            const rangePriceSettings = update(state.rangePriceSettings, {
                max: {$set: maxPrice < 1 ? 1 : maxPrice}
            });
            response.rangePriceSettings = rangePriceSettings;

            return response;
        case ActionTypes.SET_HORIZONTAL_MODE:
            return {...state, isHorizontalMode: action.payload};
        case ActionTypes.SET_DATE_START_SEARCH:
            let dateStartMoment = action.payload;
            if (dateStartMoment !== null) {
                requestParams = update(state.requestParams, {
                    dateStart: {$set: dateStartMoment.format(AppConst.DATE_FORMAT)}
                });
            } else {
                requestParams = update(state.requestParams, {
                    dateStart: {$set: null}
                });
            }
            return {...state, dateStartMoment: dateStartMoment, requestParams: requestParams};
        case ActionTypes.SET_DATE_END_SEARCH:
            let dateEndMoment = action.payload;
            if (dateEndMoment !== null) {
                requestParams = update(state.requestParams, {
                    dateEnd: {$set: dateEndMoment.format(AppConst.DATE_FORMAT)}
                });
            } else {
                requestParams = update(state.requestParams, {
                    dateEnd: {$set: null}
                });
            }
            return {...state, dateEndMoment: dateEndMoment, requestParams: requestParams};
        case ActionTypes.SET_TYPE_TERM:
            index = state.requestParams.typeTerms.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    typeTerms: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    typeTerms: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_LIFESTYLES:
            index = state.requestParams.lifestyles.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    lifestyles: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    lifestyles: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_TYPE_APARTMENTS:
            index = state.requestParams.typeApartments.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    typeApartments: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    typeApartments: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_COUNT_GUESTS:
            let countGuests = action.payload === state.requestParams.countGuests ? 0 : action.payload;
            requestParams = update(state.requestParams, {
                countGuests: {$set: countGuests}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_COUNT_BEDROOMS:
            let countBedrooms = action.payload === state.requestParams.countBedrooms ? 0 : action.payload;
            requestParams = update(state.requestParams, {
                countBedrooms: {$set: countBedrooms}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_COUNT_BATHROOMS:
            let countBathrooms = action.payload === state.requestParams.countBathrooms ? 0 : action.payload;
            requestParams = update(state.requestParams, {
                countBathrooms: {$set: countBathrooms}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_COUNT_BEDS:
            let countBeds = action.payload === state.requestParams.countBeds ? 0 : action.payload;
            requestParams = update(state.requestParams, {
                countBeds: {$set: countBeds}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_OUR_EXCLUSIVE:
            if (action.payload) {
                requestParams = update(state.requestParams, {
                    rangeTypeValues: {$push: [ObjectConst.RANGE_TYPE.EXCLUSIVE]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    rangeTypeValues: {$set: []}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_NEW_TYPE_VALUES:
            if (action.payload) {
                requestParams = update(state.requestParams, {
                    newTypeValues: {$push: [ObjectConst.NEW_TYPE.NEW]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    newTypeValues: {$set: []}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_AMENITIES:
            index = state.requestParams.amenities.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    amenities: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    amenities: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_ADDRESS:
            requestParams = update(state.requestParams, {
                address: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_PAGE_SIZE:
            requestParams = update(state.requestParams, {
                pageSize: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_PAGE:
            requestParams = update(state.requestParams, {
                page: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_ORDER:
            requestParams = update(state.requestParams, {
                order: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_RANGE_AREA:
            requestParams = update(state.requestParams, {
                minArea: {$set: action.payload.min},
                maxArea: {$set: action.payload.max}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_RANGE_PRICE:
            requestParams = update(state.requestParams, {
                minPrice: {$set: action.payload.min},
                maxPrice: {$set: action.payload.max}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_MIN_AREA:
            requestParams = update(state.requestParams, {
                minArea: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_MAX_AREA:
            requestParams = update(state.requestParams, {
                maxArea: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_MIN_PRICE:
            requestParams = update(state.requestParams, {
                minPrice: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_MAX_PRICE:
            requestParams = update(state.requestParams, {
                maxPrice: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_PLACE_ID:
            requestParams = update(state.requestParams, {
                placeIds: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_MAP_DATA:
            return {
                ...state, requestParams: {
                    ...state.requestParams,
                    centerLat: action.payload.centerLat,
                    centerLng: action.payload.centerLng,
                    placeIds: action.payload.placeId,
                    address: action.payload.address,
                    boundMaxLat: action.payload.boundMaxLat,
                    boundMinLat: action.payload.boundMinLat,
                    boundMaxLng: action.payload.boundMaxLng,
                    boundMinLng: action.payload.boundMinLng
                }
            };
        case ActionTypes.SET_IS_SHOW_ALL_FILTERS:
            return {...state, isShowAllFilters: action.payload};
        case ActionTypes.SET_IS_SHOW_ADVANCED_SEARCH:
            return {...state, isShowAdvancedSearch: action.payload};
        case ActionTypes.SET_POOL_VALUES:
            index = state.requestParams.poolValues.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    poolValues: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    poolValues: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_GARAGE_VALUES:
            index = state.requestParams.garageValues.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    garageValues: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    garageValues: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_GARDEN_VALUES:
            index = state.requestParams.gardenValues.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    gardenValues: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    gardenValues: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_FLOOR_VALUES:
            index = state.requestParams.floorValues.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    floorValues: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    floorValues: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_ORIENTATION_VALUES:
            index = state.requestParams.orientationValues.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    orientationValues: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    orientationValues: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_VIEWS_VALUES:
            index = state.requestParams.viewsValues.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    viewsValues: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    viewsValues: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_CONDITION_VALUES:
            index = state.requestParams.conditionValues.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    conditionValues: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    conditionValues: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_KITCHEN_VALUES:
            index = state.requestParams.kitchenValues.indexOf(action.payload);
            if (index > -1) {
                requestParams = update(state.requestParams, {
                    kitchenValues: {$splice: [[index, 1]]}
                });
            } else {
                requestParams = update(state.requestParams, {
                    kitchenValues: {$push: [action.payload]}
                });
            }
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_MIN_YEAR_OF_CONSTRUCTION:
            requestParams = update(state.requestParams, {
                minYearOfConstruction: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_MAX_YEAR_OF_CONSTRUCTION:
            requestParams = update(state.requestParams, {
                maxYearOfConstruction: {$set: action.payload}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_RANGE_YEAR_OF_CONSTRUCTION:
            requestParams = update(state.requestParams, {
                minYearOfConstruction: {$set: action.payload.min},
                maxYearOfConstruction: {$set: action.payload.max}
            });
            return {...state, requestParams: requestParams};
        case ActionTypes.SET_EASY_FURNITURE:
            requestParams = state.requestParams;
            index = state.requestParams.amenities.indexOf(ObjectConst.OBJECT_REPRESENT_FIELDS.EASE_FURNITURE.value);
            if (!action.payload) {
                requestParams = update(state.requestParams, {
                    amenities: {$splice: [[index, 1]]}
                });
            } else if (index === -1) {
                requestParams = update(state.requestParams, {
                    amenities: {$push: [ObjectConst.OBJECT_REPRESENT_FIELDS.EASE_FURNITURE.value]}
                });
            }
            return {...state, requestParams: requestParams};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/SearchPage.js